export type TUser = {
  username: string;
  fullName: string | null;
  role: TUserRole[];
  email: string | null;
  phone: string | null;
  companyCode: string | null;
  companyName: string | null;
  storeCode: string | null;
  storeName: string | null;
};

export type TUserRole = {
  roleCode: EUserRoles;
  roleName: string;
};

export enum EUserRoles {
  ADMIN = "ADMIN",
  STORE_OWNER = "STORE_OWNER",
}

export enum EUserAccessRoles {
  ADMIN = "ADMIN",
  STORE_OWNER = "STORE_OWNER",
}

export type TListUserReq = {
  username: string;
  name: string;
  companyCode: string;
  storeCode: string;
  role: number | string;
  pageIndex: number;
};

export type TFormUserReq = Omit<TListUserReq, "pageIndex">;

export type TListUserRes = {
  id: string;
  userName: string;
  name: string;
  companyCode: string;
  storeCode: string;
  role: string;
  companyName: string;
  storeName: string;
  isDeleted: boolean;
};

export type TListUserTable = TListUserRes & {
  key: number;
};

export type TFormModalUserRegisterReq = {
  username: string;
  name: string;
  password: string;
  companyCode: string;
  storeCode: string;
  role: number;
};

export type TGetStoreByCompany = {
  companyCode: string;
  companyName: string;
};

export type TFormDetailUserRes = {
  id: string;
  userName: string;
  name: string;
  companyCode: string;
  storeCode: string;
  role: number | undefined;
};

export type TFormUserModalRes = {
  id: string;
  userName: string;
  name: string;
  companyCode: string;
  storeCode: string;
  role: string;
  companyName: string;
  storeName: string;
  isDeleted: boolean;
};

export type TRegisUserReq = {
  username: string;
  name: string;
  password: string;
  companyCode: string;
  storeCode: string;
  role: number;
};

export type TUpdateUserReq = TRegisUserReq & {
  id?: string;
};

export type TCheckSUserExitsReq = {
  username: string;
  companyCode: string;
  storeCode: string;
  role: string;
};

export type TSearchUserResponse = {
  id: string;
  userName: string;
  fullName: string;
  roleCode: string;
  companyCode: string;
  companyName: string;
  storeCode: string;
  storeName: string;
  processingCenterCode: string;
  processingCenterName: string;
};

export type TDetailUserResponse = {
  id: string;
  userName: string;
  fullName: string;
  roleCode: string;
  companyId: string;
  companyCode: string;
  companyName: string;
  storeId: string;
  storeCode: string;
  storeName: string;
  processingCenterId: string;
  processingCenterCode: string;
  processingCenterName: string;
};
